import { onBeforeUnmount, onMounted, ref } from 'vue';

export function useScrollProgress() {
  const progress = ref(0);
  const scrollY = ref(0);

  const prefersReducedMotion = typeof window !== 'undefined'
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;

  const updateProgress = () => {
    const doc = document.documentElement;
    const scrollHeight = doc.scrollHeight - window.innerHeight;
    const current = window.scrollY || doc.scrollTop;
    scrollY.value = current;
    progress.value = scrollHeight > 0 ? Math.min(100, (current / scrollHeight) * 100) : 0;
  };

  onMounted(() => {
    updateProgress();
    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress, { passive: true });
  });

  onBeforeUnmount(() => {
    window.removeEventListener('scroll', updateProgress);
    window.removeEventListener('resize', updateProgress);
  });

  return { progress, scrollY, prefersReducedMotion };
}
